<div
  class="vw-100 h-100 position-relative d-flex align-center min-w-{{
    minWidth
  }}"
  [ngClass]="{ 'justify-center': !isModal }"
>
  <button
    class="btn-register w-200 h-36"
    [ngClass]="{ float: isModal }"
    (click)="handleViewMore()"
  >
    Ver mais
  </button>
</div>
